import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/error.tsx");
